/**
 * TalentObjectType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file TalentObjectType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum TalentObjectType {
  TalentObject = 0x01,
  TalentSpell = 0x02,
  TalentFeat = 0x04,
  TalentSkill = 0x08,
}